import StickyPageHeader from '../components/common/StickyPageHeader';
import UserList from '../components/lists/UserList';
import { useCarriers, useUsers } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminUsersPage = ({ routes }) => {
  const { allCarriers } = useCarriers();
  const { allUsers } = useUsers();

  return (
    <>
      <StickyPageHeader
        isAdmin
        title="Settings / Users"
      />
      <Layout
        showCarriersNavigation
        disableLoading={false}
        menuIndex={0}
        routes={routes}
      >
        <UserList carriers={allCarriers} id="users" users={allUsers} />
      </Layout>
    </>
  );
};

export default AdminUsersPage;
